var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex align-center"},[_vm._t("default"),_c('FormCustomer',{attrs:{"event":"create"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }